/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Popover,
  MenuItem,
  Checkbox,
  TextField,
  IconButton,
  Typography,
  ListItemText,
  Autocomplete,
  TableContainer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider as MuiDivider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash';
import {
  roleNameFormatter,
  unixToHumanReadable,
  GroupBasedRoleFormatter
} from '../../components/common';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { API } from '../../../../api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
// import Upvotes from '../../components/Upvotes';
// import MatchFilter from './components/MatchFilter';
import RoleTypeTag from '../../components/RoleTypeTag';
import { useLoader } from '../../components/useLoader';
import ChatProfile from '../chat/chat-main/ChatProfile';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useModule } from '../../../../utils/useModule';
import RecruitNewMentor from '../home/RecruitNewMentor';
// import MyPagination from '../../components/MyPagination';
import ChatAvatarComponent from '../chat/ChatAvatarComponent';
import AssignMatchPopup1 from './components/AssignMatchPopup1';
import AssignMatchPopup2 from './components/AssignMatchPopup2';
import ConfirmationPopup from './components/ConfirmationPopup';
import MatchDetailsPopup from './components/MatchDetailsPopup';
import MatchDeleteDialog from './components/MatchDeleteDialog';
import { CommonStyle, adminPanel } from '../../../../utils/muiStyle';
import { PreviewIcon, ProfilePersonIcon } from '../../../../utils/Icons';
//import ExportButton from '../Program/components/program tabs/ExportButton';
import { setMessageAuto } from '../../../../redux/slices/AutoMatchMessage';
import AppLoader from '../../../../components/AppLoader';
//import ExportPopover from '../Program/components/program tabs/ExportPopover';
import { fetchMatches, matchesActions } from '../../../../redux/slices/getAllMatches/getAllMatchesSlice';
import { eventTracking, events } from '../../../../utils/amplitude';
import AddIcon from '@mui/icons-material/Add';
import DosenAutocomplete from '../../components/DosenAutocomplete';
import DosenInput from '../../components/DosenInput';

interface MatchingFields {
  gender: boolean;
  firstGenStudent: boolean;
  ethnicity: boolean;
  disability: boolean;
  hobbies: boolean;
  major: boolean;
  university: boolean;
  industry: boolean;
  title: boolean;
  topics: boolean;
  industries: boolean;
  objectives: boolean;
}

interface SelectMentorsProps {
  memberList: Array<{
    displayName: string;
    role: string;
    headshot: string;
    major: boolean;
    university: boolean;
    industry: boolean;
    title: boolean;
    topics: boolean;
    industries: boolean;
    // Add other properties as needed
  }>;
  hasAnyTrueValue: boolean;
  assignIdFunction: (selectedOption: any) => void;
  setSelectValueMentor: React.Dispatch<React.SetStateAction<boolean>>;
  setMentorId: React.Dispatch<React.SetStateAction<string>>;
  setMenteeId: React.Dispatch<React.SetStateAction<string>>;
}

interface Recommendation {
  role: string;
  searchQuery: { field: string; value: string; match: string }[];
  matchedFieldsCount: number;
  mentorId: string;
  menteeId: string;
  headshot: string;
  displayName: string;
  bio: string;
}

interface DataItem {
  message: string;
  id: string;
  data: {
    grpId: string;
    isConfirmed: boolean;
    matchStatus: string;
    futureCalls: number;
    pastCalls: number;
    lastConnection: any;
    id: string;
    searchQuery: {
      field: string;
      value: string;
      isMatched: boolean;
    }[];
    // mentee: {
    //   bio: {
    //     education: {
    //       university: string;
    //       major: string;
    //       graduationDate: string;
    //     };
    //     workHistory: {
    //       companyName: string;
    //       role: string;
    //     };
    //   };
    //   displayName: string;
    //   id: string;
    //   headshot: string;
    //   goalProgress: number;
    // };
    // mentor: {
    //   bio: {
    //     workHistory: {
    //       companyName: string;
    //       role: string;
    //     };
    //     education: {
    //       university: string;
    //       major: string;
    //       graduationDate: string;
    //     };
    //   };
    //   displayName: string;
    //   id: string;
    //   headshot: string;
    // };
  };
  mentee: {
    bio: {
      education: {
        university: string;
        major: string;
        graduationDate: string;
      };
      workHistory: {
        companyName: string;
        role: string;
      };
    };
    displayName: string;
    id: string;
    headshot: string;
    goalProgress: number;
  };
  mentor: {
    bio: {
      workHistory: {
        companyName: string;
        role: string;
      };
      education: {
        university: string;
        major: string;
        graduationDate: string;
      };
    };
    displayName: string;
    id: string;
    headshot: string;
  };
  isConfirmed: boolean;
  matchStatus: string;
}

type MemberRole = 'Mentor' | 'Mentee';

interface MemberMatchEntry {
  match: any;
  counterpart: any;
  counterpartRole: MemberRole;
  statusLabel: string;
  statusColor: string;
  objectivesLabel: string;
}

interface MemberEntry {
  id: string;
  role: MemberRole;
  displayName: string;
  headshot?: string;
  bio?: any;
  matches: MemberMatchEntry[];
}

const matchGridTemplate =
  '24px minmax(180px, 2fr) minmax(160px, 1.5fr) minmax(140px, 1fr) minmax(120px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(150px, 1.1fr) 48px';

const initialMatchingFields: MatchingFields = {
  gender: false,
  firstGenStudent: false,
  ethnicity: false,
  disability: false,
  hobbies: false,
  major: false,
  university: false,
  industry: false,
  title: false,
  topics: false,
  industries: false,
  objectives: false
};

/** Select member field */
const SelectMentors: React.FC<SelectMentorsProps> = ({
  memberList,
  hasAnyTrueValue,
  setMentorId,
  setMenteeId,
  assignIdFunction,
  setSelectValueMentor
}) => {
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');

  const [search, setSearch] = useState('');
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // 🔎 filtra lista
  const filteredList = useMemo(() => {
    if (!search.trim()) return memberList;
    return memberList.filter((item) =>
      item.displayName.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, memberList]);

  const handleSelect = (option: any) => {
    const isSelected = selectedId === option._id;

    if (isSelected) {
      // desmarcar
      setSelectedId(null);
      setMentorId('');
      setMenteeId('');
      setSelectValueMentor(false);
      return;
    }

    // marcar novo
    setSelectedId(option._id);
    assignIdFunction(option);
    setSelectValueMentor(true);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} width="100%" sx={{backgroundColor: 'black', color: 'white'}}>
      {/* 🔎 Search bar */}
      <DosenInput
        placeholder="Search..."
        value={search}
        disabled={hasAnyTrueValue}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
      />

      {/* 📄 Lista de opções */}
      <Box
        sx={{
          maxHeight: 320,
          overflowY: 'auto',
          borderRadius: '8px',
          border: '1px solid #2A2A2A',
          background: '#121212',
          p: 1
        }}
      >
        {filteredList.map((option: any) => {
          const isSelected = selectedId === option._id;

          return (
            <MenuItem
              key={option._id}
              onClick={() => !hasAnyTrueValue && handleSelect(option)}
              disabled={hasAnyTrueValue}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: hasAnyTrueValue ? 'not-allowed' : 'pointer',
                py: 1.2
              }}
            >
              {/* ⬅️ Checkbox */}
              <Checkbox checked={isSelected} />

              {/* Conteúdo customizado */}
              <Box
                gap={'8px'}
                display={'flex'}
                alignItems={'center'}
                width="calc(100% - 60px)"
              >
                <ChatAvatarComponent
                  image={option.headshot}
                  firstLetter={option.displayName?.slice(0, 1)}
                  width={'40px'}
                  height={'40px'}
                  cursor="pointer"
                  type="noStatus"
                />

                <Box width="calc(100% - 64px)">
                  <Box display={'flex'} gap={'8px'}>
                    <Typography variant="h5" noWrap>
                      {option.displayName}
                    </Typography>
                    <RoleTypeTag category={option.role} />
                  </Box>
                  <Typography noWrap>Testing bio</Typography>
                </Box>
              </Box>
            </MenuItem>
          );
        })}
      </Box>
    </Box>
  );
};


const MatchesMainPage = () => {
  /** Common Design classes */
  const CommonClass = CommonStyle();
  const { isMentorship } = useModule();
  const ImageNameBox = `${CommonClass.gap} ${CommonClass.displayFlex} ${CommonClass.alignItemsCenter}`;
  const params = useParams();
  const grpId = params.id || '';
  const orgId = params.orgId || '';
  const coId = params.orgId || '';
  
  const dispatch: any = useAppDispatch();
  const groupUsers = useAppSelector((state) => state.groupUsers);
  const allMatchesData = useAppSelector((state) => state?.getAllMatchesList?.data);
  const loading = useAppSelector((state) => state?.getAllMatchesList?.loading);
  const error = useAppSelector((state) => state?.getAllMatchesList?.error);
  const messageAutoMatch = useAppSelector((state) => state?.message?.message);
  const matchesCount =
    (allMatchesData &&
      Array.isArray(allMatchesData.matches) &&
      allMatchesData.matches.filter((match) => match && !match.isConfirmed).length) ||
    0;
  const [dataArray, setDataArray] = useState<DataItem[]>([]);
  const confirmedCount = dataArray.filter((item) => !item?.data?.isConfirmed).length;
  const [matchingFields, setMatchingFields] = useState<MatchingFields>(initialMatchingFields);
  const [recommendations, setRecommendations] = useState<Recommendation[]>([]);
  const [suggestions, setSuggestions] = useState<Recommendation[]>([]);
  const [selectedRecommendation, setSelectedRecommendation] = useState<Recommendation | null>(null);
  const [openAssignMentor, setOpenAssignMentor] = useState(false);
  const [openAssignMentorSecond, setOpenAssignMentorSecond] = useState(false);
  const [userId, setUserId] = useState<string>('');
  let [menteeId, setMenteeId] = useState('');
  let [mentorId, setMentorId] = useState('');
  const [action, setAction] = useState('');
  const apiAssigneeRole = action === 'Assign Mentor' ? 'Mentee' : action === 'Assign Mentee' ? 'Mentor' : 'Mentee';
  const [memberList, setMemberList] = useState<any[]>([]);
  const [selectValueMentor, setSelectValueMentor] = useState(false);
  const [openMatchDetails, setOpenMatchDetails] = useState(false);
  const [modelConfirmMatch, setModelConfirmMatch] = useState(false);
  const [confirmMatchId, setConfirmMatchId] = useState('');
  const [loaderFirstPopup, setLoaderFirstPopup] = useState(false);
  const [loaderFirstPopup1, setLoaderFirstPopup1] = useState(false);
  const [anchorElConfirm, setAnchorElConfirm] = React.useState<HTMLButtonElement | null>(null);
  const [maxMatchCountMentee, setMatchCountMentee] = useState<number | undefined>();
  const [maxMatchCountMentor, setMatchCountMentor] = useState<number | undefined>();
  const openConfirm = Boolean(anchorElConfirm);
  const idConfirm = openConfirm ? 'simple-popover' : undefined;
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [matchDetails, setMatchDetails] = useState();
  const [matchSingle, setMatchSingle] = useState<any>();
  const [activeUserId, setActiveUserId] = useState<any>();
  const [activeUserDetails, setActiveUserDetails] = useState<any>();
  const [latestEducation, setLatestEducation] = useState<any>();
  const [latestWorkHistory, setLatestWorkHistory] = useState<any>();
  const [openProfile, setOpenProfile] = useState(false);
  const [matchDetailsLoader, setMatchDetailsLoader] = useState(false);
  const [loadingUserDetails, setLoadingUserDetails] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>();
  // const [anchorExport, setAnchorExport] = React.useState<HTMLButtonElement | null>(null);
  // const [isClicked, setIsClicked] = useState(false);
  const classs = adminPanel();
  const copiedUserDetails = {
    ...activeUserDetails,
    id: activeUserDetails?.personal_details,
    bio: { education: latestEducation, workHistory: latestWorkHistory },
    education: { updatedData: activeUserDetails?.professional_details?.education },
    workHistory: { updatedData: activeUserDetails?.professional_details?.workHistory }
    // digital_intro: activeUserDetails?.digital_intro?.videoUrl
  };

  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor'); // Mentor
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee'); // Mentee
  const [openRecruitMentor, setOpenRecruitMentor] = useState(false);
  const [isAssignPopup, setIsAssignPopup] = useState(false);
  const handleCloseMatchDetails = () => {
    setOpenMatchDetails(false);
    // setLoaderFirstPopup(false);
  };
  const handleOpenMatchDetails = async () => {
    setMatchDetails(undefined);
    setAnchorElConfirm(null);
    setOpenMatchDetails(true);
    setMatchDetailsLoader(true);
    try {
      const response = await API.getMatchProfile({
        orgId: orgId,
        confirmMatchId: confirmMatchId
      });
      if (response?.status === 200) {
        setMatchDetailsLoader(false);
        setMatchDetails(response?.data?.data);
      }
    } catch (error) {}
  };

  const handleOpenRecruitMentor = (isAssign: boolean) => {
    setIsAssignPopup(isAssign);
    setOpenRecruitMentor(true);
  };

  const handleCloseRecruitMentor = () => {
    setOpenRecruitMentor(false);
    setIsAssignPopup(false);
  };

  const handleOpenAssignForMember = (member: MemberEntry) => {
    const nextAction = member.role === 'Mentor' ? 'Assign Mentee' : 'Assign Mentor';
    setAction(nextAction);
    setSelectedRecommendation(null);
    setUserId(member.id);
    if (isMentorship) {
      handleOpenRecruitMentor(true);
    } else {
      setOpenAssignMentor(true);
    }
  };

  const handleCloseAssignMentor = () => {
    setOpenAssignMentor(false);
    setLoaderFirstPopup(false);
    setMatchingFields(initialMatchingFields);
    setLoaderFirstPopup1(false);
    setMentorId('');
    setMenteeId('');
    setSelectValueMentor(false);
  };

  const fetchAllMembers = async () => {
    const response = await API.getListToAssignMatch({
      orgId: orgId,
      userId: userId || activeUserId,
      grpId: grpId !== 'admin' ? grpId : coId,
      data: {
        assigneeRole: apiAssigneeRole
      },
      isMatchingFields: false
    });
    if (response?.data?.data) {
      setMemberList(response?.data?.data);
    }
  };

  const assignIdFunction = (selectedOption: any) => {
    if (selectedOption.role === 'Mentee') {
      // setAssigneeId(selectedOption?.menteeId);
      setMentorId(userId);
      setMenteeId(selectedOption?.menteeId);
    }
    if (selectedOption.role === 'Mentor') {
      // setAssigneeId(selectedOption?.mentorId);
      setMentorId(selectedOption?.mentorId);
      setMenteeId(userId);
    }
  };

  const handleOpenFindmentor = async (event: React.FormEvent) => {
    const hasTrueValue = Object.values(matchingFields).some((value) => value === true);

    if (selectValueMentor === false && hasTrueValue === false) {
      toast.error('Please make a selection');
      return;
    }

    if (isMentorship) {
      setMatchingFields({
        ...initialMatchingFields,
        objectives: true
      });

      setLoaderFirstPopup(true);
      event.preventDefault();

      try {
        const response = await API.getListToAssignMatch({
          orgId: orgId,
          userId: userId || activeUserId,
          grpId: grpId !== 'admin' ? grpId : coId,
          data: {
            assigneeRole: apiAssigneeRole,
            matchingFields: {
              ...initialMatchingFields,
              objectives: true
            }
          },
          isMatchingFields: true
        });

        if (response?.status === 200) {
          setRecommendations(response.data?.data?.recommendations);
          setSuggestions(response.data?.data?.suggestions);
          setMenteeId(response.data?.data?.MenteeId);
          setMentorId(response.data?.data?.MentorId);
          setLoaderFirstPopup(false);
        } else {
          setLoaderFirstPopup(false);
          toast.error(response?.data?.message || 'Failed to find matches');
        }

        setOpenAssignMentorSecond(true);
        setOpenAssignMentor(false);
      } catch (error) {
        setLoaderFirstPopup(false);
        toast.error('Failed to find matches');
      }
      return;
    }

    if (selectValueMentor === false && hasTrueValue) {
      setLoaderFirstPopup(true);
      event.preventDefault();
      const response = await API.getListToAssignMatch({
        orgId: orgId,
        userId: userId || activeUserId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          assigneeRole: apiAssigneeRole,
          matchingFields
        },
        isMatchingFields: true
      });

      if (response?.status === 200) {
        setRecommendations(response.data?.data?.recommendations);
        setSuggestions(response.data?.data?.suggestions);
        setMenteeId(response.data?.data?.MenteeId);
        setMentorId(response.data?.data?.MentorId);
        setLoaderFirstPopup(false);
        setMatchingFields(initialMatchingFields);
      } else {
        setLoaderFirstPopup(false);
        setMatchingFields(initialMatchingFields);
        if (response?.status === 400) {
          toast.error('User has reached their maximum number of matches');
        }
      }

      setOpenAssignMentorSecond(true);
      setOpenAssignMentor(false);
    }

    // selecting from list
    if (selectValueMentor === true) {
      setLoaderFirstPopup(true);
      const response = await API.assignAMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          mentorId: mentorId,
          menteeId: menteeId,
          assigneeRole: apiAssigneeRole
        }
      });

      if (response?.status === 200) {
        setLoaderFirstPopup(false);

        const matchesData = response.data?.data
          ? Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data]
          : [];

        if (matchesData.length > 0) {
          setDataArray([...dataArray, ...matchesData]);

          matchesData.forEach((match: any) => {
            dispatch(
              matchesActions.updateMenteesMentors({
                menteeId: match.mentee?.userId,
                mentorId: match.mentor?.userId
              })
            );
          });
        }
        eventTracking(events.matchCreated, {
          groupId: grpId,
          orgId,
          assigneeRole: apiAssigneeRole,
          matchSource: 'assignment-list',
          matchCount: matchesData.length
        });

        if (action === 'Assign Mentor') {
          toast.success(mentorRoleText + ' assigned successfully');
        }
        if (action === 'Assign Mentee') {
          toast.success(menteeRoleText + ' assigned successfully');
        }
      } else {
        setLoaderFirstPopup(false);
        toast.error('Something went wrong, please try again');
      }
      setOpenAssignMentor(false);
      setMenteeId('');
      setMentorId('');
      setSelectValueMentor(false);
    }
  };

  const handleClickOpenAutoMatch = () => {
    //   setOpen(true);
    setAction('Auto Match');
    setOpenAssignMentor(true);
  };

  const handelCloseAssineMatch = () => {
    setOpenAssignMentor(false);
    setOpenAssignMentorSecond(false);
    setLoaderFirstPopup(false);
    setLoaderFirstPopup1(false);
    setMentorId('');
    setMenteeId('');
    setSelectValueMentor(false);
  };

  const handleSubmitAssignMatch = async () => {
    setLoaderFirstPopup(true);

    // const searchQuery = selectedRecommendation?.searchQuery.map((query) => ({
    //   field: query.field,
    //   value: query.value,
    //   match: query.match
    // }));
    if (selectedRecommendation) {
      const response = await API.assignAMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          mentorId: action === 'Assign Mentor' ? selectedRecommendation?.mentorId : mentorId || activeUserId,
          menteeId: action === 'Assign Mentor' ? menteeId || activeUserId : selectedRecommendation?.menteeId,
          // searchQuery
          assigneeRole: apiAssigneeRole
        }
      });

      if (response?.status === 200) {
        setLoaderFirstPopup(false);
        const matchesData = response.data?.data
          ? Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data]
          : [];

        if (matchesData.length > 0) {
          setDataArray([...dataArray, ...matchesData]);

          matchesData.forEach((match: any) => {
            dispatch(
              matchesActions.updateMenteesMentors({
                menteeId: action === 'Assign Mentor' ? menteeId || activeUserId : match.mentee?.userId,
                mentorId: action === 'Assign Mentor' ? match.mentor?.userId : mentorId || activeUserId
              })
            );
          });
        }
        dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
        eventTracking(events.matchCreated, {
          groupId: grpId,
          orgId,
          assigneeRole: apiAssigneeRole,
          matchSource: 'recommendation',
          matchCount: matchesData.length
        });
        if (action === 'Assign Mentor') {
          toast.success(mentorRoleText + ' assigned successfully');
        }
        if (action === 'Assign Mentee') {
          toast.success(menteeRoleText + ' assigned successfully');
        }
      } else {
        toast.error('Something went wrong, please try again');
      }
    }

    setOpenAssignMentor(false);
    setOpenAssignMentorSecond(false);
    setLoaderFirstPopup(false);
    setMenteeId('');
    setMentorId('');
  };

  const handleConfirmMatch = async (id: string) => {
    setAnchorElConfirm(null);
    setConfirmMatchId(id);
    setModelConfirmMatch(true);
  };

  const handleOpenMatchPopover = async (id: string, event: React.MouseEvent<HTMLButtonElement>) => {
    const matchFromApi = allMatchesData?.matches?.find((ele: any) => ele.id === id);
    const matchFromLocal = dataArray.find((ele) => ele.id === id || _.get(ele, 'data.id') === id);
    const match = matchFromApi || matchFromLocal;
    if (match) setMatchSingle(match);
    setConfirmMatchId(id);
    setAnchorElConfirm(event.currentTarget);
    setOpenProfile(false);
  };

  const handleCloseConfirmMatch = async () => {
    setModelConfirmMatch(false);
    setLoaderFirstPopup(false);
  };

  const handleConfirmAll = async () => {
    setLoaderFirstPopup1(true);
    try {
      const response = await API.confirmAllMatches({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId
      });

      if (response?.status === 200) {
        const updatedDataArray = dataArray.map((item) => {
          item.isConfirmed = true;
          return item;
        });
        eventTracking(events.matchByAdmin, {});
        setDataArray(updatedDataArray);

        dispatch(matchesActions.updateConfirmStatusAll());
        setLoaderFirstPopup1(false);
        setLoaderFirstPopup(false);
        toast.success('All matches are confirmed successfully');
        setAnchorElConfirm(null);
      } else {
        setLoaderFirstPopup1(false);
        setLoaderFirstPopup(false);
        toast.error('Somthing went wrong');
      }
    } catch (error) {}
    setModelConfirmMatch(false);
  };

  const handelSubmitConfirmMatch = async () => {
    setLoaderFirstPopup(true);
    try {
      const response = await API.confirmMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          id: confirmMatchId
        }
      });

      if (response?.status === 200) {
        eventTracking(events.matchByAdmin, {});
        const updatedDataArray = dataArray.map((item) => {
          if (item.id === response?.data?.data?.id) {
            item.isConfirmed = true;
          }
          return item;
        });

        setDataArray(updatedDataArray);
        dispatch(matchesActions.updateConfirmStatus(response?.data?.data?.id));
        dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
        setLoaderFirstPopup(false);
        toast.success('Match confirmed successfully');
        setAnchorElConfirm(null);
      } else {
        toast.error('Something went wrong, please try again');
        setLoaderFirstPopup(false);
      }
    } catch (error) {}
    setModelConfirmMatch(false);
  };

  const handelOpenProfile = (id: string) => {
    setSelectedUserId(id);
  };

  const getUserProfileDetails = async () => {
    if (selectedUserId) {
      try {
        setOpenProfile(false);
        const response = await API.getUserProfileInAGroup(grpId !== 'admin' ? grpId : coId, selectedUserId);
        if (response?.status === 200) {
          setActiveUserDetails(response?.data?.userDetails);
          setOpenProfile(true);
        } else {
          setOpenProfile(false);
          toast.error('Profile details failed to load');
        }
        setSelectedUserId('');
      } catch (e) {
        setOpenProfile(false);
        toast.error('Profile details failed to load');
      }
    }
  };

  const handleCloseConfirmPopover = () => {
    setAnchorElConfirm(null);
  };

  const getMaxMatches = async () => {
    try {
      const response = await API.getAllMatchesSetting({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId
      });

      if (response?.status === 200) {
        const { maxMatchesPerMentor, maxMatchesPerMentee } = response.data.data.matchesSettings;
        setMatchCountMentee(maxMatchesPerMentee);
        setMatchCountMentor(maxMatchesPerMentor);
      } else {
      }
    } catch (error) {
      toast.error('Matches failed to load');
    }
  };

  const handleOpendelete = () => {
    setOpenDelete(true);
    setAnchorElConfirm(null);
  };

  const handeleDeleteMatch = async () => {
    setDeleteLoader(true);
    try {
      const response = await API.removeMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        confirmMatchId: confirmMatchId
      });

      if (response?.status === 200) {
        setDeleteLoader(false);
        setOpenDelete(false);
        const updatedDataArray = dataArray.map((item) => {
          if (item.data.id === confirmMatchId) {
            item.data.matchStatus = 'Inactive';
          }
          return item;
        });
        setDataArray(updatedDataArray);
        dispatch(matchesActions.endMatch(confirmMatchId));
        dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
        toast.success('Match ended successfully.');
      }
    } catch (error) {
      toast.error('Match failed to end');
    }
  };

  useEffect(() => {
    if (selectedUserId) {
      getUserProfileDetails();
    }
  }, [selectedUserId]);

  useEffect(() => {
    setLatestEducation(
      activeUserDetails?.professional_details?.education?.sort(
        (a: any, b: any) => b?.graduation_date - a?.graduation_date
      )[0]
    );
    setLatestWorkHistory(
      activeUserDetails?.professional_details?.workHistory
        ?.filter((a: any) => a.currentlyWorking === true)
        ?.sort((a: any, b: any) => b.start_date - a.start_date)[0]
    );
  }, [activeUserDetails]);

  useEffect(() => {
    getMaxMatches();
  }, []);

  useEffect(() => {
    fetchAllMembers();
  }, [action]);

  const handleSubmitAutoMatch = async () => {
    setLoaderFirstPopup(true);
    const response = await API.autoMatch({
      orgId: orgId,
      grpId: grpId !== 'admin' ? grpId : coId,
      data: {
        maxMatchesPerMentor: maxMatchCountMentor,
        maxMatchesPerMentee: maxMatchCountMentee,
        matchingFields
      }
    });

    if (response?.status === 200) {
      setOpenAssignMentor(false);
      setLoaderFirstPopup(false);
      dispatch(setMessageAuto(response.data.message));
      toast.success('Auto match completed successfully');
      setMatchingFields(initialMatchingFields);
      if (response.data === 'Auto-matching completed') {
        dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
      }
    } else {
      toast.error('Somthing went wrong');
      setLoaderFirstPopup(false);
    }
  };

  window.addEventListener('beforeunload', () => {
    dispatch(setMessageAuto(''));
  });

  useEffect(() => {
    dispatch(setMessageAuto(''));
  }, []);

  useEffect(() => {
    if (orgId && grpId) {
      dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
    }
  }, [orgId, grpId, dispatch]);

  const showLoader = useLoader(loading, 1000);

  /** search */
  const [searchValue, setSearchValue] = useState('');

  const filterData = (data: any[], searchValue: string) => {
    if (Array.isArray(data)) {
      return data.filter((item) => {
        // filter by mentee or mentor name
        return (
          item?.mentee?.displayName.toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.mentor?.displayName.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    }
    return [];
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const memberCount =
    (allMatchesData?.matches && Array.isArray(allMatchesData.matches) ? allMatchesData.matches.length : 0) +
    (allMatchesData?.mentees && Array.isArray(allMatchesData.mentees) ? allMatchesData.mentees.length : 0) +
    (allMatchesData?.mentors && Array.isArray(allMatchesData.mentors) ? allMatchesData.mentors.length : 0);

  const getMatchesList = () => {
    if (!allMatchesData) {
      return (
        <Box
          sx={{
            width: '100%',
            py: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#B6B6B6',
            fontSize: 16,
            fontWeight: 500
          }}
        >
          No matches available yet.
        </Box>
      );
    }

    const storedMatches: any[] = Array.isArray(allMatchesData.matches) ? (allMatchesData.matches as any[]) : [];
    const rawMatchesList: any[] = [...storedMatches, ...dataArray];
    const matchKey = (match: any) =>
      match?.id || match?._id || _.get(match, 'data.id') || _.get(match, 'data._id') || _.get(match, 'match.id');
    const uniqueMatchesMap = new Map<string, any>();
    rawMatchesList.forEach((match, index) => {
      const key = matchKey(match) || `match-${index}`;
      if (!uniqueMatchesMap.has(key)) {
        uniqueMatchesMap.set(key, match);
      }
    });
    const matchesList: any[] = Array.from(uniqueMatchesMap.values());
    const mentorsList: any[] = Array.isArray(allMatchesData.mentors) ? (allMatchesData.mentors as any[]) : [];
    const menteesList: any[] = Array.isArray(allMatchesData.mentees) ? (allMatchesData.mentees as any[]) : [];

    const memberMap: Record<string, MemberEntry> = {};

    const ensureMember = (member: any, role: MemberRole): MemberEntry | null => {
      const id =
        member?.userId || member?.id || member?.mentorId || member?.menteeId || member?.personal_details || '';
      if (!id) {
        return null;
      }
      if (!memberMap[id]) {
        memberMap[id] = {
          id,
          role,
          displayName: member.displayName || member?.name || 'Unnamed',
          headshot: member?.headshot,
          bio: member?.bio,
          matches: []
        };
      }
      return memberMap[id];
    };

    const getStatusInfo = (match: any) => {
      const label =
        match?.matchStatus === 'Inactive'
          ? 'Ended'
          : match?.isConfirmed
          ? 'Ongoing'
          : 'Pending';
      const color = label === 'Ongoing' ? '#F79420' : label === 'Ended' ? '#868686' : '#FFB800';
      return { statusLabel: label, statusColor: color };
    };

    const getObjectivesLabel = (match: any) => {
      const objectivesCount =
        _.get(match, 'data.objectives.length') || match?.objectives?.length || 0;
      return objectivesCount ? `${objectivesCount} objectives` : 'No objectives';
    };

    matchesList.forEach((match) => {
      const mentor = match?.mentor ?? {};
      const mentee = match?.mentee ?? {};
      const { statusLabel, statusColor } = getStatusInfo(match);
      const objectivesLabel = getObjectivesLabel(match);
      const mentorEntry = ensureMember(mentor, 'Mentor');
      const menteeEntry = ensureMember(mentee, 'Mentee');

      if (mentorEntry) {
        mentorEntry.matches.push({
          match,
          counterpart: mentee,
          counterpartRole: 'Mentee',
          statusLabel,
          statusColor,
          objectivesLabel
        });
      }
      if (menteeEntry) {
        menteeEntry.matches.push({
          match,
          counterpart: mentor,
          counterpartRole: 'Mentor',
          statusLabel,
          statusColor,
          objectivesLabel
        });
      }
    });

    mentorsList.forEach((mentor) => ensureMember(mentor, 'Mentor'));
    menteesList.forEach((mentee) => ensureMember(mentee, 'Mentee'));

    const memberEntries = Object.values(memberMap).sort((a, b) => {
      if (a.role !== b.role) {
        return a.role === 'Mentor' ? -1 : 1;
      }
      return a.displayName.localeCompare(b.displayName);
    });

    if (!memberEntries.length) {
      return (
        <Box
          sx={{
            width: '100%',
            py: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#B6B6B6',
            fontSize: 16,
            fontWeight: 500
          }}
        >
          No members are available to match yet.
        </Box>
      );
    }

    return (
      <Box display="flex" flexDirection="column" gap={1.5} pb={2}>
        {memberEntries.map((member) => {
          const totalPastCalls = member.matches.reduce(
            (sum, entry) => sum + (entry.match?.pastCalls ?? 0),
            0
          );
          const totalFutureCalls = member.matches.reduce(
            (sum, entry) => sum + (entry.match?.futureCalls ?? 0),
            0
          );
          const connections = member.matches
            .map((entry) => entry.match?.lastConnection)
            .filter(Boolean)
            .sort((a, b) => (b || 0) - (a || 0));
          const lastConnection = connections[0];
          const summaryMatch =
            member.matches.find((entry) => entry.statusLabel === 'Ongoing') || member.matches[0];
          const summaryStatusLabel = summaryMatch?.statusLabel || (member.matches.length ? 'Pending' : 'No matches');
          const summaryStatusColor = summaryMatch?.statusColor || '#868686';
          const summaryObjectives = summaryMatch?.objectivesLabel || 'No objectives';
          const matchCountLabel = `${member.matches.length} match${member.matches.length === 1 ? '' : 'es'}`;

          return (
            <Accordion
              key={member.id}
              disableGutters
              sx={{
                background: '#0F0F0F',
                color: '#FDFDFD'
              }}
            >
              <AccordionSummary
                sx={{
                  px: 3.4,
                  // py: 1.25,
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #444444',
                  minHeight: 'unset',
                  '.MuiAccordionSummary-expandIconWrapper': {
                    order: -1,
                    marginRight: 0,
                    width: 24,
                    display: 'flex',
                    justifyContent: 'center'
                  }
                }}
                expandIcon={<ExpandMoreIcon sx={{ color: '#FDFDFD', fontSize: 20 }} />}
              >
                {/* <ExpandMoreIcon sx={{ color: '#FDFDFD', fontSize: 20 }} /> */}
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: matchGridTemplate,
                    alignItems: 'center',
                    width: '100%',
                    gap: 1.5
                  }}
                >
                  <Box />
                  <Box sx={{display: 'flex'}}>
                    <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600, mr: 1 }}>
                      {member.displayName}
                    </Typography>
                    <Button
                      variant="text"
                      onClick={() => handleOpenAssignForMember(member)}
                      sx={{
                        color: '#F79420',
                        fontWeight: 600,
                        fontSize: 10,
                        textTransform: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        // gap: 0.75,
                        borderRadius: '6px',
                        padding: 0
                      }}
                    >
                      <AddIcon sx={{ fontSize: 16 }} />
                      Assign Match
                    </Button>
                    
                    {/* <Typography sx={{ color: '#868686', fontSize: 12, fontWeight: 500 }} noWrap>
                      {member.role}
                    </Typography> */}
                  </Box>
                    
                 
                  {/* <Typography sx={{ color: summaryStatusColor, fontSize: 14, fontWeight: 600 }} noWrap>
                    {summaryStatusLabel}
                  </Typography> */}
                  {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }} noWrap>
                    {summaryObjectives}
                  </Typography> */}
                  {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }}>
                    {totalPastCalls}
                  </Typography>
                  <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }}>
                    {totalFutureCalls}
                  </Typography>
                  <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'right' }}>
                    {lastConnection ? unixToHumanReadable(lastConnection) : '—'}
                  </Typography>
                   */}
                </Box>
              </AccordionSummary>

              <AccordionDetails sx={{ px: 2.5, py: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {member.matches.length === 0 ? (
                  <Box
                    sx={{
                      px: 0.5,
                      py: 1,
                      color: '#868686',
                      fontSize: 13
                    }}
                  >
                    No matches yet. Click “Assign Match” to add one.
                  </Box>
                ) : (
                  member.matches.map((entry, idx) => {
                    const { match, counterpart, counterpartRole, statusLabel, statusColor, objectivesLabel } = entry;
                    const matchId =
                      match?.id ||
                      match?._id ||
                      _.get(match, 'data.id') ||
                      _.get(match, 'data._id') ||
                      _.get(match, 'match.id');
                    const fallbackKey = matchId || `${member.id}-match-${idx}`;
                    const lastConnectionText = match?.lastConnection
                      ? unixToHumanReadable(match.lastConnection)
                      : '—';

                    return (
                      <Box
                        key={fallbackKey}
                        sx={{
                          px: 1.5,
                          display: 'grid',
                          gridTemplateColumns: matchGridTemplate,
                          // alignItems: 'center',
                          gap: 1.5,
                          // borderRadius: '6px',
                          // border: '1px solid #2A2A2A',
                          background: '#0F0F0F'
                        }}
                      >
                        <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600 }}>{}</Typography>
                        <Box>
                          <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 600 }} noWrap>
                            {counterpart?.displayName || 'Unnamed'}
                          </Typography>
                          {/* <RoleTypeTag category={counterpartRole} /> */}
                        </Box>
                        <Typography sx={{ color: '#F79420', fontSize: 14 }} noWrap>
                          {/* {matchId ? matchId.slice(0, 6) : 'Match'} */}
                           {member.displayName}
                        </Typography>
                        <Typography sx={{ color: statusColor, fontSize: 14, fontWeight: 600 }} noWrap>
                          {statusLabel}
                        </Typography>
                        {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {objectivesLabel}
                        </Typography> */}
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {match?.pastCalls ?? 0}
                        </Typography>
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {match?.futureCalls ?? 0}
                        </Typography>
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'right' }}>
                          {lastConnectionText}
                        </Typography>
                        <IconButton
                          disabled={!matchId}
                          onClick={(event) => matchId && handleOpenMatchPopover(matchId, event)}
                        >
                          <MoreVertIcon sx={{ color: '#FDFDFD' }} />
                        </IconButton>
                      </Box>
                    );
                  })
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    );
  };

  const member = memberList;
  const hasAnyTrueValue = Object.values(matchingFields).some((value) => value === true);

  const [page, setPage] = useState(1);
  const itemsPerPage = 25;
  const totalItems = 10 * itemsPerPage; // 10 pages * 25 items per page
  const totalPages = 10; // Total number of pages

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleExportMatches = async () => {
    try {
      const response = await API.exportMatches({
        grpId: grpId,
        orgId: orgId
      });

      if (response.data?.message === 'Exported successfully') {
        toast.success('Your report will be emailed to you shortly');
      } else {
        toast.error('Export Failed');
      }
    } catch (error) {
      toast.error('Failed to export matches');
    }
  };

  /** Export Button Popover */
  // const handleClickExport = (event: any) => {
  //   setAnchorExport(event.currentTarget);
  //   setIsClicked(true);
  // };

  // const handleCloseExport = () => {
  //   setAnchorExport(null);
  //   setIsClicked(false);
  // };

  // const handleClickDownloadPdf = (event: any) => { };

  // const handleClickExportExcel = (event: any) => { };

  // const handleClickExportPlan = (event: any) => { };

  // const openExport = Boolean(anchorExport);

  return (
    <>
        {showLoader ? (
          <AppLoader />
        ) : (
        <Box className={classs.mainBody} sx={{ bgcolor: '#0F0F0F !important', color: '#FDFDFD !important' }}>
          <Box display="flex" height="100%">
            <Box flex="1 1 auto" minWidth={0} height="100%">
              {allMatchesData && allMatchesData && (
                <TableContainer sx={{ height: '100%', backgroundColor: '#0F0F0F !important', color: '#FDFDFD !important' }}>
                  <Box
                    px={3}
                    py={2.5}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid #1C1C1C"
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography sx={{ color: '#B6B6B6', fontSize: 16, fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
                        {memberCount || 0} Member{memberCount === 1 ? '' : 's'}
                      </Typography>
                    </Box>
                    {/* <Box display="flex" alignItems="center" gap={1.5}>
                      <Button
                        onClick={() => toast.info('Export coming soon')}
                        sx={{
                          px: 1.75,
                          py: 1.25,
                          background: '#1C1C1C',
                          borderRadius: '6px',
                          color: '#FDFDFD',
                          border: '1px solid #1C1C1C',
                          fontSize: 13,
                          fontWeight: 500,
                          textTransform: 'none',
                          minWidth: 120,
                          '&:hover': { background: '#2A2A2A' }
                        }}
                      >
                        Export Data
                      </Button>
                      <Button
                        onClick={() => toast.info('Manual invite coming soon')}
                        sx={{
                          px: 1.5,
                          py: 1.25,
                          background: '#565656',
                          borderRadius: '6px',
                          color: '#FDFDFD',
                          border: '1px solid #0F0F0F',
                          fontSize: 13,
                          fontWeight: 500,
                          textTransform: 'none',
                          minWidth: 140,
                          '&:hover': { background: '#656565' }
                        }}
                        startIcon={
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              border: '1.5px solid #FDFDFD',
                              borderRadius: '2px'
                            }}
                          />
                        }
                      >
                        Manual Invite
                      </Button>
                    </Box> */}
                  </Box>
                  <Divider sx={{ opacity: 0.1, border: '.5px' }} />
                  <Box sx={{ px: 2, py: 2, height: 'calc(100% - 72px)', overflowY: 'auto' }}>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: matchGridTemplate,
                    alignItems: 'center',
                    color: '#868686',
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    columnGap: 6,
                    width: '100%'
                  }}
                >
                  <Box />
                  <Box sx={{ textAlign: 'left' }}>Name</Box>
                  <Box sx={{ textAlign: 'left' }}>Matches</Box>
                  <Box sx={{ textAlign: 'left' }}>Status</Box>
                  <Box sx={{ textAlign: 'left' }}>Past Meetings</Box>
                  <Box sx={{ textAlign: 'left' }}>Future Meetings</Box>
                  <Box sx={{ textAlign: 'left' }}>Last Connection</Box>
                  <Box />
                </Box>
                    {typeof allMatchesData.matches === 'string' &&
                    typeof allMatchesData.mentees === 'string' &&
                    typeof allMatchesData.mentors === 'string' ? (
                      <Typography textAlign="center" sx={{ color: '#FDFDFD', py: 4 }}>
                        No members are available to match yet
                      </Typography>
                    ) : (
                      getMatchesList()
                    )}
                  </Box>
                </TableContainer>
              )}
            </Box>
          <Popover
            id={idConfirm}
            open={openConfirm}
            anchorEl={anchorElConfirm}
            onClose={handleCloseConfirmPopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            {matchSingle?.matchStatus === 'Inactive' && (
              <Box className="PopoverListStyle">
                <ProfilePersonIcon />
                <Typography color="primary">Ended</Typography>
              </Box>
            )}
            {matchSingle?.isConfirmed && matchSingle?.matchStatus === 'Active' && (
              <Box className="PopoverListStyle" onClick={handleOpendelete}>
                <ProfilePersonIcon />
                <Typography color="primary">Remove match</Typography>
              </Box>
            )}
            {matchSingle?.isConfirmed === false && (
              <Box className="PopoverListStyle" onClick={() => handleConfirmMatch(_.get(matchSingle, 'id'))}>
                <ProfilePersonIcon />
                <Typography color="primary">Confirm Match</Typography>
              </Box>
            )}
            <Box className="PopoverListStyle" onClick={handleOpenMatchDetails}>
              <PreviewIcon />
              <Typography color="primary">View match details</Typography>
            </Box>
          </Popover>
            {openProfile && activeUserDetails && (
              <Box width="350px" flex="0 0 350px" height="100%">
                <ChatProfile
                  workHistory={copiedUserDetails?.workHistory}
                  educationDetails={copiedUserDetails?.education}
                  chatProfile={copiedUserDetails}
                  onCloseChatProfile={() => {
                    setOpenProfile(false);
                  }}
                  parentComponent="sideSmallProfile"
                  // loading={true}
                />
              </Box>
            )}
          </Box>

          {/* Assign a mentor first Popup */}
          <AssignMatchPopup1
            handleCloseAssignMentor={handleCloseAssignMentor}
            openAssignMentor={openAssignMentor}
            action={action}
            handleOpenFindmentor={handleOpenFindmentor}
            matchingFields={matchingFields}
            setMatchingFields={setMatchingFields}
            handleSubmitAutoMatch={handleSubmitAutoMatch}
            maxMatchCountMentee={maxMatchCountMentee}
            maxMatchCountMentor={maxMatchCountMentor}
            setMatchCountMentee={setMatchCountMentee}
            setMatchCountMentor={setMatchCountMentor}
            loaderFirstPopup={loaderFirstPopup}
            selectMentors={
              <SelectMentors
                memberList={member}
                hasAnyTrueValue={hasAnyTrueValue}
                assignIdFunction={assignIdFunction}
                setSelectValueMentor={setSelectValueMentor}
                setMentorId={setMentorId}
                setMenteeId={setMenteeId}
              />
            }
            selectValueMentor={selectValueMentor}
          />

          {/* Assign a mentor second popup */}
          <AssignMatchPopup2
            openAssignMentorSecond={openAssignMentorSecond}
            handelCloseAssineMatch={handelCloseAssineMatch}
            action={action}
            recommendations={recommendations}
            suggestions={suggestions}
            setSelectedRecommendation={setSelectedRecommendation}
            handleSubmitAssignMatch={handleSubmitAssignMatch}
            loaderFirstPopup={loaderFirstPopup}
          />

          {/* Matches confirmation popup code */}
          <ConfirmationPopup
            matchesCount={matchesCount}
            confirmedCount={confirmedCount}
            modelConfirmMatch={modelConfirmMatch}
            handleCloseConfirmMatch={handleCloseConfirmMatch}
            handelSubmitConfirmMatch={handelSubmitConfirmMatch}
            handleConfirmAll={handleConfirmAll}
            loaderFirstPopup={loaderFirstPopup}
            loaderFirstPopup1={loaderFirstPopup1}
          />

          {/* Match details popup */}
          <MatchDetailsPopup
            openMatchDetails={openMatchDetails}
            handleCloseMatchDetails={handleCloseMatchDetails}
            matchDetails={matchDetails}
            matchDetailsLoader={matchDetailsLoader}
          />

          {/* Match delete popup */}
          <MatchDeleteDialog
            openDelete={openDelete}
            setOpenDelete={setOpenDelete}
            deleteLoader={deleteLoader}
            handeleDeleteMatch={handeleDeleteMatch}
          />

          {openRecruitMentor && (
            <RecruitNewMentor
            origin='admin'
              open={openRecruitMentor}
              onClose={handleCloseRecruitMentor}
              mentorsList={[]}
              onProfileClick={(mid: any) => {
                handelOpenProfile(mid);
              }}
              onChatClick={(mentor: any) => {
                console.log('Chat with', mentor);
              }}
              onCalendarClick={(mentor: any) => {
                console.log('Schedule with', mentor);
              }}
              objId=""
              grpId={grpId !== 'admin' ? grpId : coId}
              isAssignPopup={isAssignPopup}
              assigneeRole={action}
              userId={userId}
              onSelect={(selectedMenteeId: any) => {
                setMenteeId(selectedMenteeId);
              }}
              dataArray={dataArray}
              setDataArray={setDataArray}
              apiType="match"
            />
          )}

          {/* MatchFilter */}
        </Box>
      )}
    </>
  );
};

export default MatchesMainPage;
